import { GETTING_USER_EMPLOYMENT_INFO, UPDATE_USER_EMPLOYMENT_INFO } from '../actions/actionTypes';

import {
  EMPLOYMENT_STATUS,
  FULL_TIME_VALUE,
  OCCUPATION_LABEL,
  JOB_TITLE_LABEL,
  JOB_DURATION_LABEL,
  CURRENT_ANNUAL_SALARY,
  BONUSES,
  COMMISSIONS,
  YEARS,
  MONTHS,
  TOTAL_INCOME,
} from '../constants/Dashboard/Employment';

const DEFAULT_STATE = {
  [EMPLOYMENT_STATUS]: FULL_TIME_VALUE,
  [OCCUPATION_LABEL]: '',
  [JOB_TITLE_LABEL]: '',
  [JOB_DURATION_LABEL]: {
    [YEARS]: 2,
    [MONTHS]: 0,
  },
  loading: false,
};

export const employmentReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case GETTING_USER_EMPLOYMENT_INFO:
      return {
        ...state,
        loading: true,
      };

    case UPDATE_USER_EMPLOYMENT_INFO:
      if (Object.keys(action.payload).length) {
        return {
          ...state,
          loading: false,
          ...action.payload,
          [EMPLOYMENT_STATUS]: action.payload.employmentStatus,
          [OCCUPATION_LABEL]: action.payload.occupation,
          [JOB_TITLE_LABEL]: action.payload.jobTitle,
          [CURRENT_ANNUAL_SALARY]: action.payload.annualSalary,
          [BONUSES]: action.payload.bonuses,
          [COMMISSIONS]: action.payload.commissions,
          [JOB_DURATION_LABEL]: {
            [YEARS]: action.payload.jobDurationYears,
            [MONTHS]: action.payload.jobDurationMonths,
          },
          [TOTAL_INCOME]:
            Number(action.payload.annualSalary) +
            Number(action.payload.commissions) +
            Number(action.payload.bonuses),
        };
      }

    default:
      return {
        ...state,
        loading: false,
      };
  }
};
